<wl-card heading="Utilities" subheading1="{{subheading1}}" subheading2="{{subheading2}}">

  <mat-tab-group>
    <mat-tab label="Add New User" *ngIf="superAdminOrMaker">

      <h3 class="text-center">New User Registration</h3>
      <form novalidate [formGroup]="addUserForm" class="formWidth" #formDirective="ngForm" [formGroup]="addUserForm"
        (ngSubmit)="addUser(formDirective)">
        <mat-select *ngIf="!superAdminUser && !centralOfficeUser" formControlName="access_level"
          placeholder="Select Access Level" class="w-full" (selectionChange)="accessSelected($event.value)" >

          <mat-option *ngFor="let accessLevel of distnew | slice:1:4;" [value]="accessLevel.id">
            {{accessLevel.name}}</mat-option>
        </mat-select>
        <mat-select *ngIf="superAdminUser || centralOfficeUser" formControlName="access_level"
          placeholder="Select Access Level" class="w-full" (selectionChange)="accessSelected($event.value)">
          <mat-option *ngFor="let accessLevel of distnew | slice:0:4;" [value]="accessLevel.id">
            {{accessLevel.name}}</mat-option>
        </mat-select>
        <br> <br> <br>
        <mat-select *ngIf="coSelected && superAdminUser" formControlName="profile" placeholder="Select Profile Level"
          class="w-full mt-neg1rem" (selectionChange)="profileSelected($event.value)">
          <mat-option value="centralOffice">Central Office Admin</mat-option>
          <mat-option value="maker">Maker</mat-option>
          <mat-option value="checker">Checker</mat-option>
        </mat-select>
        <mat-select *ngIf="coSelected && centralOfficeUser" formControlName="profile" placeholder="Select Profile Level"
          class="w-full mt-neg1rem" (selectionChange)="profileSelected($event.value)">
          <mat-option value="maker">Maker</mat-option>
          <mat-option value="checker">Checker</mat-option>
        </mat-select>
        <mat-select *ngIf="zonalSelected && superAdminUser || zonalSelected && centralOfficeUser"
          formControlName="profile" placeholder="Select Profile Level" class="w-full mt-neg1rem"
          (selectionChange)="profileSelected($event.value)">
          <mat-option value="zoneAdmin">Zone Admin</mat-option>
          <mat-option value="zoneuser">Zone User</mat-option>
        </mat-select>
        <mat-select *ngIf="roSelected && superAdminUser || roSelected && centralOfficeUser" formControlName="profile"
          placeholder="Select Profile Level" class="w-full mt-neg1rem"
          (selectionChange)="profileSelected($event.value)">
          <mat-option value="roAdmin">RO Admin</mat-option>
          <mat-option value="roUser">RO User</mat-option>
        </mat-select>
        <mat-select *ngIf="branchSelected && superAdminUser || branchSelected && centralOfficeUser"
          formControlName="profile" placeholder="Select Profile Level" class="w-full mt-neg1rem"
          (selectionChange)="profileSelected($event.value)">
          <mat-option value="branchAdmin">Branch Admin</mat-option>
        </mat-select>
        <br> <br>
        <br>

        <div
          [ngClass]="( (coSelected||zonalSelected||roSelected||branchSelected) && (superAdminUser) || (coSelected||zonalSelected||roSelected||branchSelected) && (centralOfficeUser)) ? 'reduceSpacenCO' : 'reduceSpace'">
          <wl-autocomplete-bi class="w-full mt-20px" label="" placeholder="{{codePlaceholder}}"
            formControlName="branchName" [options]="options" (selected)="zoneSelected($event)"
            [disabled]="coOfficeCode">
          </wl-autocomplete-bi>
        </div>
        <br>

        <mat-form-field appearance="outline" class="w-full">
          <input type="text" matInput placeholder="{{branchPlaceholder}}" formControlName="code" readonly>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <input type="text" matInput placeholder="Enter Name" formControlName="staffName"
            onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32 )">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <input type="text" matInput placeholder="Enter Staff ID" maxlength="8" formControlName="staffId"
            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <input type="text" maxlength="10" matInput placeholder="Enter Mobile Number" formControlName="mobileNo"
            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <input type="text" matInput placeholder="Enter Email ID" formControlName="email">
        </mat-form-field>
        <div class="text-center">
          <button class="mybutton" [disabled]="!addUserForm.valid">Create User</button>
        </div>

      </form>


    </mat-tab>

    <mat-tab label="Transfer a User" *ngIf="superAdminOrMaker">
      <h3 class="text-center">Transfer User</h3>


      <form novalidate [formGroup]="transferForm" class="formWidth" #formDirective="ngForm">

        <div class="disableUserDetail">
          <mat-form-field appearance="outline" class="w-80pct">
            <input type="text" matInput placeholder="Enter Staff ID" maxlength="8" formControlName="staffId"
              [(ngModel)]="pfNo"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="isStaffIdReadOnly">
          </mat-form-field>
          <button class="mybutton w-20pct" [disabled]="!pfNo"
            (click)="fetchUserDetails(pfNo,'transfer')">{{viewOrHideDetailsButtonText}}</button>
        </div>
        <div class="disableUserInfo" *ngIf="showTransferUserDetail">
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="STATE" [readonly]="true" formControlName="state">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="ZONE" [readonly]="true" formControlName="zone">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="RO" [readonly]="true" formControlName="ro">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="BRANCH" [readonly]="true" formControlName="branch">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="NAME" [readonly]="true" formControlName="name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="MOBILE NO" [readonly]="true" formControlName="mobileNo">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="EMAIL ADDRESS" [readonly]="true" formControlName="email">
          </mat-form-field>
        </div>

        <div class="disableUserDetail">
          <mat-form-field appearance="outline" class="w-80pct">
            <input type="text" matInput placeholder="Enter Zone/RO/Branch Sol Id" formControlName="zrbcode"
              [readonly]="isSolIdReadOnly" [(ngModel)]="solId">
          </mat-form-field>
          <button class="mybutton w-20pct" [disabled]="!solId"
            (click)="fetchSolIdDetails(solId)">{{viewDetailsSolIdText}}</button>
        </div>

        <div class="disableUserInfo" *ngIf="showSolIdDetail">
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="STATE" [readonly]="true" formControlName="state_name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="ZONE" [readonly]="true" formControlName="zone_name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="ZONE SOL ID" [readonly]="true" formControlName="zone_code">
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="solIdType == 'Branch' || solIdType == 'RO' ">
            <input type="text" matInput placeholder="RO" [readonly]="true" formControlName="ro_name">
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="solIdType == 'Branch' || solIdType == 'RO' ">
            <input type="text" matInput placeholder="RO SOL ID" [readonly]="true" formControlName="ro_code">
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="solIdType == 'Branch'">
            <input type="text" matInput placeholder="BRANCH" [readonly]="true" formControlName="branch_name">
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="solIdType == 'Branch'">
            <input type="text" matInput placeholder="BRANCH SOL ID" [readonly]="true" formControlName="branch_code">
          </mat-form-field>
        </div>
        <br><br><br>
        <div class="text-center">
          <button class="mybutton" [disabled]="!transferForm.valid || !isSolIdReadOnly"
            (click)="transferSubmit(formDirective)">Transfer
            User</button>
        </div>


      </form>
    </mat-tab>

    <mat-tab label="Disable user" *ngIf="superAdminOrMaker">
      <h3 class="text-center">Disable user</h3>
      <form novalidate [formGroup]="disableForm">
        <div class="disableUser">
          <div class="disableUserDetail">
            <mat-form-field appearance="outline" class="flex-4">
              <input type="text" matInput placeholder="PF NO" maxlength="6" [(ngModel)]="pfNumber"
                formControlName="pfNumber"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
            </mat-form-field>
            <button class="mybutton" [disabled]="!pfNumber" (click)="fetchUserDetails(pfNumber,'disable')">View
              Details</button>
          </div>
          <div class="disableUserInfo" *ngIf="disableUserDetails">
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="STATE" [readonly]="true" [(ngModel)]="disableUserDetails.state"
                formControlName="state">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="ZONE" [readonly]="true"
                [(ngModel)]="disableUserDetails.zone_name" formControlName="zone">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="RO" [readonly]="true" [(ngModel)]="disableUserDetails.ro_name"
                formControlName="ro">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="BRANCH" [readonly]="true"
                [(ngModel)]="disableUserDetails.branch_name" formControlName="branch">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="NAME" [readonly]="true"
                [(ngModel)]="disableUserDetails.staffName" formControlName="staffName">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="MOBILE NO" [readonly]="true"
                [(ngModel)]="disableUserDetails.mobileNo" formControlName="mobileNo">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input type="text" matInput placeholder="EMAIL ADDRESS" [readonly]="true"
                [(ngModel)]="disableUserDetails.email" formControlName="">
            </mat-form-field>
          </div>
          <div class="disableUserCTA" *ngIf="disableUserDetails">
            <button class="mybutton" (click)="openDisableUserConfirmModal()">Disable User</button>
            <button class="mybutton" (click)="onDisableUserCancel()">Cancel</button>
          </div>
        </div>
      </form>
    </mat-tab>

    <mat-tab label="Add User Requests" *ngIf="checkerUser">
      <!-- 5 columns (name, staff ID, mobile no. + actions) do not fit a phone.
           Scroll the table sideways inside the tab rather than letting it widen
           the page - same wrapper the other list screens already use. -->
      <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Staff ID</th>
            <th>Mobile No.</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let user of allUsersDetails;let i = index;">



            <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>
            <td class="vertical-align-middle w-16pct">{{user.request.staffName}}</td>
            <td class="vertical-align-middle w-16pct">{{user.request.staffId}}</td>
            <td class="vertical-align-middle">{{user.request.mobileNo}}</td>


            <td class="vertical-align-middle p-4px text-center">
              <a class="text-no-decoration cursor-pointer text-blue" color="primary" target="_blank"
                (click)="showDetails(user)">View Details</a>
            </td>


          </tr>



        </tbody>
      </table>
      </div>


      <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
        <ul class="pagination">

          <li *ngIf="page>3"><a (click)="getAllUsersPage('',roleId,offset - 10,10,page - 1)">Previous</a></li>
          <li *ngIf="page>2"><a (click)="getAllUsersPage('',roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
          <li *ngIf="page>1"><a (click)="getAllUsersPage('',roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
          <li class="page-item active"><a (click)="getAllUsersPage('',roleId,offset,10,page)">{{page}}</a></li>
          <li *ngIf="page<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 10,10,page + 1)">{{page + 1}}</a>
          </li>
          <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 20,10,page + 2)">{{page + 2}}</a>
          </li>
          <li *ngIf="page<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 10,10,page + 1)">Next</a></li>
        </ul>
      </nav>
      <app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
      <wl-progress [hidden]="isDataPending"></wl-progress>
    </mat-tab>

    <mat-tab label="Transfer User Requests" *ngIf="checkerUser">

      <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Branch/RO/ZO Sol Id</th>
            <th>Staff ID</th>
            <th class="text-center" *ngIf="makerOnly">Actions</th>
          </tr>
        </thead>

        <tbody>

          <tr *ngFor="let user of transferDetails;let i = index;">



            <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>
            <td class="vertical-align-middle">{{user?.TransferToData?.zrbcode }} </td>
            <td class="vertical-align-middle w-16pct">{{user?.staffId}}</td>



            <td class="vertical-align-middle p-4px text-center">
              <a class="text-no-decoration cursor-pointer text-blue" color="primary" target="_blank"
                (click)="showTransferUserDetails(user)">View Details</a>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

    </mat-tab>

    <mat-tab label="Reset Password" *ngIf="superAdminOrMaker">
      <h3 class="text-center">Reset Password</h3>
      <form novalidate [formGroup]="resetForm" class="formWidth" #formDirective="ngForm">

        <div class="disableUserDetail">
          <mat-form-field appearance="outline" class="w-80pct">
            <input type="text" matInput placeholder="Enter Staff ID" maxlength="8" formControlName="staffId"
              [(ngModel)]="pfNoReset"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="isStaffIdReadOnlyReset">
          </mat-form-field>
          <button class="mybutton w-20pct" [disabled]="!pfNoReset"
            (click)="fetchUserDetails(pfNoReset,'reset')">{{viewOrHideDetailsButtonTextReset}}</button>
        </div>
        <div class="disableUserInfo" *ngIf="showResetUserDetail">
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="STATE" [readonly]="true" formControlName="state">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="ZONE" [readonly]="true" formControlName="zone">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="RO" [readonly]="true" formControlName="ro">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="BRANCH" [readonly]="true" formControlName="branch">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="NAME" [readonly]="true" formControlName="name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="MOBILE NO" [readonly]="true" formControlName="mobileNo">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="EMAIL ADDRESS" [readonly]="true" formControlName="email">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-full mb-1rem">
          <input [type]="typeType" matInput placeholder="Enter New Password" formControlName="password"
            autocomplete="off" data-random="random">
        </mat-form-field>
        <div class="text-right mt-neg45px z-999">
          <img *ngIf="showPassword" (click)="togglePassword()" class="h-14px opacity-5"
            src="../../../assets/icons/eye.png" />
          <img *ngIf="!showPassword" (click)="togglePassword()" class="h-18px opacity-5"
            src="../../../assets/icons/eye_off.png" />
        </div>

        <mat-form-field appearance="outline" class="w-full mt-1rem">
          <input [type]="typeTypeConfirm" matInput placeholder="Confirm New Password" formControlName="confirmPassword"
            autocomplete="off" data-random="random">
        </mat-form-field>
        <div class="text-right mt-neg45px z-999">
          <img *ngIf="showPasswordConfirm" (click)="togglePasswordConfirm()" class="h-14px opacity-5"
            src="../../../assets/icons/eye.png" />
          <img *ngIf="!showPasswordConfirm" (click)="togglePasswordConfirm()" class="h-18px opacity-5"
            src="../../../assets/icons/eye_off.png" />
        </div>

        <mat-error
          *ngIf="resetForm.controls['password'].valid && (resetForm.controls['password'].value !=resetForm.controls['confirmPassword'].value)">
          <br>
          <span>Your password and confirmation password should match.</span>
        </mat-error>
        <mat-error *ngIf="resetForm.controls['password'].invalid || resetForm.controls['confirmPassword'].invalid">
          <br>Password should atleast be 10 characters length and should contain one special character, one lower case
          letter, one upper case letter and one number.</mat-error>

        <br><br><br>
        <div class="text-center">
          <button class="mybutton"
            [disabled]="!resetForm.valid || (resetForm.controls['password'].value !=resetForm.controls['confirmPassword'].value)"
            (click)="resetPasswordSubmit(resetForm.value)">Reset Password</button>
        </div>


      </form>

    </mat-tab>
  </mat-tab-group>

</wl-card>




<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />